import { TIME_SCALES, SEARCH_BY } from '../summary/constants.tsx';

export const REPORT_DEFAULTS = {
	searchByPastSevenDays: TIME_SCALES.past7Days,
	timeBreakdown: SEARCH_BY.daily,
} as const;
